import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {GetInterfaceLang, GetOneLanguage, GetOneLearningLanguage,deleteLiveSituations, getLiveSituations, saveRule, getDetailSituation, addLiveSituations, updateTranslationLiveSituations, DelRule, GetChatPerson, updateLiveSituations, addTranslationLiveSituations} from '../../actions/index';
import {Link} from 'react-router';

class AddRule  extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state={
            word: '',
            type: 'select',
            person: false
        }
        $('body').on('click','.hint_block span.selected', (e)=> {
            if($(e.target).closest('.col-md-4').hasClass('has-error')){
                $(e.target).closest('.col-md-4').removeClass('has-error')
            }
            if($(e.target).hasClass('active')){
                $(e.target).removeClass('active');
            }else{
                $(e.target).addClass('active');
            }
            // $(this).toggleClass('active');
            // that.props.fields.missed_words.onChange($('#missed_words').html());
            this.props.fields[$(e.target).parent().attr('name')].onChange($(e.target).parent().text());
        });
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetInterfaceLang(token);
        this.props.GetChatPerson(token);
        this.props.GetOneLearningLanguage(this.props.params.id, token);
        if(this.props.params.id_situation){
            this.props.getDetailSituation(this.props.params.id_situation, token, this.props.params.id);
        }else{
            this.props.lang.situation_one = {}
        }
    }
    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
        $('.selectpicker').selectpicker();
        $('#word').keypress(function () {
            $(this).parent().removeClass('has-error')
        });
    }
    componentDidUpdate(){
        $('.selectpicker').selectpicker('refresh');
    }
    componentWillUnmount(){
        this.props.lang.situation_one = {}
        $('body').off('click', '.hint_block span.selected');
        this.setState({
            person: false
        });
    }
    circleFor=(arr, block, name)=>{
        for(let i=0; i<block.length; i++){
            let oneBlock = block[i];
            if($(oneBlock).find('textarea').val() == ''){
                $(oneBlock).addClass('has-error');
            }
        }
    }
    returnObjSentence=(id)=>{
        let words = []
        for(let i =0; i<$(id+' span').length; i++){
            let oneWord = $(id+' span')[i]
            let obj = {
                word: $(oneWord).text(),
                visibly: $(oneWord).hasClass('active') ? true : false,
                count: $(oneWord).text().length
            }
            words.push(obj)
        }
        return words
    }
    SubmitForm=(props)=>{
        $('.btn.btn-primary').prop("disabled", true);
        let token = localStorage.getItem('id_token_admin');
        let block_description = $('.translate_description .addWordBlock');
        let block_time_answer1 = $('.translate_time_answer1 .addWordBlock');
        let block_time_answer2 = $('.translate_time_answer2 .addWordBlock');
        let block_answer1 = $('.translate_answer1 .addWordBlock');
        let block_answer2 = $('.translate_answer2 .addWordBlock');
        let arr_description = [];
        let arr_time_answer1 = [];
        let arr_time_answer2 = [];
        let arr_answer1 = [];
        let arr_answer2 = [];
        this.circleFor(arr_description,block_description, 'description');
        if(props.type == '1'){
            this.circleFor(arr_answer1,block_answer1, 'answer1');
            this.circleFor(arr_answer2,block_answer2, 'answer2');
        }
        if(props.type == '2'){
            this.circleFor(arr_time_answer1,block_time_answer1, 'audio_answer1');
            this.circleFor(arr_time_answer2,block_time_answer2, 'audio_answer2');
            if ($('#hint1 span.active').length == 0) {
                $('#hint1').closest('.col-md-4').addClass('has-error');
            }
            if ($('#hint2 span.active').length == 0) {
                $('#hint2').closest('.col-md-4').addClass('has-error');
            }
        }

        if($('.situation_rule').find('.has-error').length > 0){$('.btn.btn-primary').prop("disabled", false); return false}else{
            props.flang = this.props.params.id;
            props.translations = []

            if(props.type == '1'){
                delete props.audio_bot1
                delete props.audio_bot2
                delete props.hint1
                delete props.hint2
                delete props.phrase_audio_answer1
                delete props.phrase_audio_answer2
                delete props.time_answer1
                delete props.time_answer2
                let dataForm = new FormData()
                if(typeof props.audio_answer1 != 'string'){
                    dataForm.append('audio_answer1', props.audio_answer1);
                    delete props.audio_answer1
                }
                if(typeof props.audio_answer2 != 'string'){
                    dataForm.append('audio_answer2', props.audio_answer2);
                    delete props.audio_answer2
                }
                if(typeof props.audio_answer1 == 'string'){
                    delete props.audio_answer1
                }
                if(typeof props.audio_answer2 == 'string'){
                    delete props.audio_answer2
                }
                this.props.lang.interface_lang.results.forEach((item)=>{
                    if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                        return false
                    }else {
                        let obj = {
                            blang: item.id,
                            description: $('.translate_description').find('.addWordBlock#' + item.id).find('textarea').val(),
                            answer1: $('.translate_answer1').find('.addWordBlock#' + item.id).find('textarea').val(),
                            answer2: $('.translate_answer2').find('.addWordBlock#' + item.id).find('textarea').val()
                        }
                        props.translations.push(obj)
                    }
                })
                if(this.props.params.id_situation){
                    this.props.updateLiveSituations(token, props, this.props.params.id_situation).then((resp)=>{
                        if(resp.payload.status == 200){
                            if(dataForm.get('audio_answer2') || dataForm.get('audio_answer1')){
                                this.props.updateLiveSituations(token, dataForm, this.props.params.id_situation)
                            }
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/live_situations');
                        }
                        $('.btn.btn-primary').prop("disabled", false);
                    })
                }else{
                    let props2 = props;
                    delete props2.audio_answer1;
                    delete props2.audio_answer2;
                    this.props.addLiveSituations(token, props2).then((resp)=>{
                        if(resp.payload.status == 201){
                            if(dataForm.get('audio_answer2') || dataForm.get('audio_answer1')){
                                this.props.updateLiveSituations(token, dataForm, resp.payload.data.id)
                            }else{
                                if(typeof props.audio_answer1 != 'string'){
                                    dataForm.append('audio_answer1', props.audio_answer1);
                                    // delete props.audio_answer1

                                }
                                if(typeof props.audio_answer2 != 'string'){
                                    dataForm.append('audio_answer2', props.audio_answer2);
                                    // delete props.audio_answer2
                                }
                                if(props.audio_answer1 || props.audio_answer2){
                                    this.props.updateLiveSituations(token, dataForm, resp.payload.data.id)
                                }
                            }
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/live_situations');
                        }
                        $('.btn.btn-primary').prop("disabled", false);
                    });
                }

            }else if(props.type == '2'){
                let dataForm
                delete props.answer1
                delete props.answer2
                props.sentence_object1 = JSON.stringify(this.returnObjSentence('#hint1'));
                props.sentence_object2 = JSON.stringify(this.returnObjSentence('#hint2'));
                props.missed_words1 = $("#hint1").html();
                props.missed_words2 = $("#hint2").html();

                if(typeof props.audio_answer1 == 'string'){
                    delete props.audio_answer1
                }
                if(typeof props.audio_answer2 == 'string'){
                    delete props.audio_answer2
                }
                if(typeof props.audio_bot1 == 'string'){
                    delete props.audio_bot1
                }
                if(typeof props.audio_bot2 == 'string'){
                    delete props.audio_bot2
                }
                if(typeof props.audio_answer1 != 'string' || typeof props.audio_answer2 != 'string' || typeof props.audio_bot1 != 'string' || typeof props.audio_bot2 != 'string'){
                    dataForm = new FormData();
                    for(let i=0; i<Object.keys(props).length; i++){
                        if(props[Object.keys(props)[i]] != undefined){
                            dataForm.append(Object.keys(props)[i], props[Object.keys(props)[i]]);
                        }
                    }
                }else{
                    dataForm = props
                }

                if(this.props.params.id_situation){
                    this.props.updateLiveSituations(token, dataForm, this.props.params.id_situation).then((resp)=>{
                        if(resp.payload.status == 200){
                            this.props.lang.interface_lang.results.forEach((item)=>{
                                if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                                    return false
                                }else {
                                    let obj = {
                                        blang: item.id,
                                        situation: resp.payload.data.id,
                                        description: $('.translate_description').find('.addWordBlock#' + item.id).find('textarea').val(),
                                        audio_answer1: $('.translate_time_answer1').find('.addWordBlock#' + item.id).find('textarea').val(),
                                        audio_answer2: $('.translate_time_answer2').find('.addWordBlock#' + item.id).find('textarea').val()
                                    }
                                    props.translations.push(obj)
                                }
                            })
                            for(let i=0; i<props.translations.length; i++){
                                let one = props.translations[i];
                                let item = _.findWhere(resp.payload.data.translations, {blang: one.blang});
                                if(_.findWhere(resp.payload.data.translations, {blang: one.blang})){
                                    this.props.updateTranslationLiveSituations(token, one, item.id);
                                } else {
                                    if (one.audio_answer1 !== '1' && one.audio_answer2 !== '1' && one.description !== '1') {
                                        this.props.addTranslationLiveSituations(token, one);
                                    }
                                }
                            }
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/live_situations');
                        }
                        $('.btn.btn-primary').prop("disabled", false);
                    })
                }else{
                    this.props.addLiveSituations(token, dataForm).then((resp)=>{
                        if(resp.payload.status == 201){
                            this.props.lang.interface_lang.results.forEach((item)=>{
                                if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                                    return false
                                }else {
                                    let obj = {
                                        blang: item.id,
                                        situation: resp.payload.data.id,
                                        description: $('.translate_description').find('.addWordBlock#' + item.id).find('textarea').val(),
                                        audio_answer1: $('.translate_time_answer1').find('.addWordBlock#' + item.id).find('textarea').val(),
                                        audio_answer2: $('.translate_time_answer2').find('.addWordBlock#' + item.id).find('textarea').val()
                                    }
                                    props.translations.push(obj)
                                }
                            })
                            for(let i=0; i<props.translations.length; i++){
                                let one = props.translations[i];
                                this.props.addTranslationLiveSituations(token, one);
                            }
                            this.context.router.push('/language/learning/edit/'+this.props.params.id+'/live_situations');
                        }
                        $('.btn.btn-primary').prop("disabled", false);
                    })
                }
            }
        }

    }
    changeInput=(e)=>{
        this.setState({
            [e.target.name]: e.target.value
        });
        $(e.target).parent().removeClass('has-error');
    }
    delRule=()=>{
        let token = localStorage.getItem('id_token_admin');
        this.props.deleteLiveSituations(token, this.props.params.id_situation).then((response)=>{
            if(response.payload.status == 204){
                $('#DelSituation').modal('hide');
                this.context.router.push('/language/learning/edit/'+this.props.params.id+'/live_situations/');
                this.props.getLiveSituations(token, this.props.params.id);
            }
        });
    }
    delRuleOpenModal=()=>{
        $('#DelSituation').modal('show');
    }
    closeModal=()=>{
        $('#DelSituation').modal('hide');
    }
    translation=(id)=>{
        if(id && this.props.lang.rule_detail.translations){
            return this.props.lang.rule_detail.translations.map((item)=>{
                if(item.blang == id){
                    return <div key={item.id} className="idetBlock" dangerouslySetInnerHTML={{__html: item.content}}></div>
                }
            });
        }else{
            return  <div className="idetBlock"></div>
        }
    }
    select=(e)=>{
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.fields[e.target.name].onChange(e.target.value)
    }
    uploadState=()=>{
        this.setState({
            person: this.props.lang.situation_one.person
        })
    }
    renderPeople=()=>(
        this.props.chat.personsList.results.map((item, i)=>(
            <div className="col-md-6" key={item.id}>
                <input type="radio" id={'person'+item.id} checked={item.id == this.state.person} onChange={this.select} name="person" value={item.id}/>
                <label htmlFor={'person'+item.id} >{item.name}</label>
            </div>
        ))
    )
    renderTranslate=(block)=>{
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item)=>{
            if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
                return false
            }else{
                return(
                    <div className='row addWordBlock sentences' id={item.id} key={item.lang.id}>
                        <div className="col-md-4">
                            <label>{item.lang.name}</label>
                        </div>
                        {this.editTranslation(item.id, block)}
                    </div>
                )
            }
        });
    }
    removeClass=(e)=>{
        $(e.target).closest('.sentences').removeClass('has-error')
    }
    editTranslation=(id, block)=>{
        if(this.props.params.id_situation){
            let item = _.findWhere(this.props.lang.situation_one.translations, {blang: id});
            if(_.findWhere(this.props.lang.situation_one.translations, {blang: id})){
                return(
                    <div className="col-md-4" key={item.id} id={item.id}>
                        <textarea className="form-control" name={item.id} defaultValue={item[block]} onChange={this.removeClass}/>
                    </div>
                )
            }
            else{
                return(
                    <div className="col-md-4" id={id}>
                        <textarea className="form-control" name={id} onChange={this.removeClass}/>
                    </div>
                )
            }
        }else{
            return(
                <div className="col-md-4" id={id}>
                    <textarea className="form-control" name={id} onChange={this.removeClass}/>
                </div>
            )
        }
    }
    onChange=(e, content)=>{
        let nameBlock = $(e).parent().data('name');
        this.setState({
            [nameBlock]: content
        })
    }
    chooseFunc=(e)=>{
        this.setState({
            [e.target.name]: e.target.value
        });
        this.props.fields[e.target.name].onChange(e.target.value);
        setTimeout(()=>{
            $('.selectpicker').selectpicker();
        }, 500)
    }
    addWordSelect=(e)=>{
        this.props.fields[e.target.name].onChange(e.target.value);
        let block = $(e.target).attr('data-block')
        $('#'+block).text(e.target.value);
        let str = $('#'+block).text().replace(/(([\wа-яА-ЯЁё\xC0-\u0192’´'-])+)/g, '<span class="selected">$1</span>');
        let str2 = str.replace(/([\,\.\!\:\“\„\‘\?\¡\¿]| - )/g, '<span class="no_selected">$1</span>');
        $('#'+block).html(str2);
    }
    handleChange=(e)=>{
        let obj = e.target.files[0];
        this.props.fields[e.target.name].onChange(obj);
        this.setState({
            [e.target.name]: obj.name
        });
    }
    render() {
        const { fields: { type, title, number, description, text1, text2, answer1, phrase_audio_answer2, phrase_audio_answer1,
            answer2, audio_bot1, audio_answer1, time_answer1, hint1, audio_bot2, missed_words2, missed_words1,
            audio_answer2, time_answer2, hint2, flang, person}, handleSubmit} = this.props;
        if(this.state.person == false && this.props.lang.situation_one.person){
            this.uploadState()
        }
        return (
            <div className="dashboard-wrapper">
                <p className="dashboard-title">{this.props.params.id_situation ? "Edit situation" : "Add situation"}</p>
                <p className="dashboard-text">Situation page</p>
                <form className="situation_rule" onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="study_type">Select type situation</label>
                                </div>
                                <div className='col-md-4'>
                                    <select className="selectpicker" name="type" id="type" disabled={type.initialValue != 'select' ? 'disabled' : ''}  {...type} data-live-search="true" onChange={this.chooseFunc}>
                                        <option value="select">Select type</option>
                                        <option value="1">Writing</option>
                                        <option value="2">Speaking</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>
                    {this.state.type != 'select' || type.initialValue != 'select' ?
                        <div className="col-md-12">
                            <div className="white-block block-4-8 clearfix chat_box_only">

                                <div className="col-md-12 name_rule_block">
                                    <div className="clearfix">
                                        <div className="col-md-4">
                                            <label htmlFor="number">Position (number)</label>
                                        </div>
                                        <div className={ number.touched && !number.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <input type="text"
                                                   id="number"
                                                   placeholder="Situation number"
                                                   className="form-control"
                                                   name="number"
                                                   {...number}
                                            />
                                        </div>
                                    </div>
                                    <div className="clearfix">
                                        <div className="col-md-4">
                                            <label htmlFor="title">Situation name</label>
                                        </div>
                                        <div className={ title.touched && !title.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <input type="text"
                                                   id="title"
                                                   placeholder="Situation name"
                                                   className="form-control"
                                                   name="title"
                                                   {...title}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12 name_rule_block">
                                    {/*<div className="clearfix">*/}
                                    {/*<div className="col-md-4">*/}
                                    {/*<label htmlFor="description">Situation description</label>*/}
                                    {/*</div>*/}
                                    {/*<div className={ description.touched && !description.valid ? 'col-md-4 has-error': 'col-md-4'}>*/}
                                    {/*<textarea className="form-control"*/}
                                    {/*name="description"*/}
                                    {/*id="description"*/}
                                    {/*{...description}*/}
                                    {/*/>*/}
                                    {/*</div>*/}
                                    {/*</div>*/}
                                    <div className="clearfix blockTranslate border-bottom-none translate_description">
                                        <p className="title">Translate situation description</p>
                                        {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.situation_one ?
                                            <div className="col-md-12">
                                                {this.renderTranslate('description')}
                                            </div>
                                            : ""
                                        }
                                    </div>
                                </div>


                                <div className="col-md-12 personBlock">
                                    <div className="clearfix">
                                        <div className="col-md-4">
                                            <label>Select Person</label>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="row">
                                                {this.props.chat.personsList.results && this.props.lang.notofication_detail ? this.renderPeople() : ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {this.state.type == '1' || type.initialValue == '1' ?
                                    <div className="writeFunc">
                                        <div className="first_situation">
                                            <div className='clearfix' style={{'marginBottom': '10px'}}>
                                                <div className="col-md-4">
                                                    <label htmlFor="text1">Situation phrase bot #1</label>
                                                </div>
                                                <div className={ text1.touched && !text1.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                                <textarea className="form-control"
                                                          name="text1"
                                                          id="text1"
                                                          {...text1}
                                                />
                                                </div>
                                            </div>

                                            <div className='clearfix'>
                                                <div className="col-md-4">
                                                    <label htmlFor="answer1">Situation phrase people #1</label>
                                                </div>
                                                <div className={ answer1.touched && !answer1.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                                <textarea className="form-control"
                                                          name="answer1"
                                                          id="answer1"
                                                          {...answer1}
                                                />
                                                </div>
                                            </div>
                                            <div className='clearfix mt10'>
                                                <div className="col-md-4">
                                                    <label>Situation audio #1</label>
                                                </div>

                                                <div className='col-md-2'>
                                                    <label htmlFor="audio_answer1" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className={audio_answer1.touched && !audio_answer1.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="audio_answer1"
                                                           id="audio_answer1"
                                                           onChange={this.handleChange}
                                                    />

                                                    <input type="text"
                                                           placeholder={audio_answer1.initialValue ? audio_answer1.initialValue :"File"}
                                                           className="form-control"
                                                           name="audio_answer1"
                                                           id="audio_answer1"
                                                           disabled
                                                           value = {this.state.audio_answer1}
                                                    />
                                                </div>
                                            </div>

                                            <div className=" personBlock">
                                                <div className="clearfix blockTranslate border-bottom-none translate_answer1">
                                                    <p className="title">Translate</p>
                                                    {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.situation_one ?
                                                        <div className="col-md-12">
                                                            {this.renderTranslate('answer1')}
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="second_situation">
                                            <div className='clearfix' style={{'marginBottom': '10px'}}>
                                                <div className="col-md-4">
                                                    <label htmlFor="text2">Situation phrase bot #2</label>
                                                </div>
                                                <div className={ text2.touched && !text2.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                                <textarea className="form-control"
                                                          name="text2"
                                                          id="text2"
                                                          {...text2}
                                                />
                                                </div>
                                            </div>

                                            <div className='clearfix mt10'>
                                                <div className="col-md-4">
                                                    <label htmlFor="answer2">Situation phrase people #2</label>
                                                </div>
                                                <div className={ answer2.touched && !answer2.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                                <textarea className="form-control"
                                                          name="answer2"
                                                          id="answer2"
                                                          {...answer2}
                                                />
                                                </div>
                                            </div>
                                            <div className='clearfix mt10'>
                                                <div className="col-md-4">
                                                    <label>Situation audio #2</label>
                                                </div>

                                                <div className='col-md-2'>
                                                    <label htmlFor="audio_answer2" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className={audio_answer2.touched && !audio_answer2.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="audio_answer2"
                                                           id="audio_answer2"
                                                           onChange={this.handleChange}
                                                    />

                                                    <input type="text"
                                                           placeholder={audio_answer2.initialValue ? audio_answer2.initialValue :"File"}
                                                           className="form-control"
                                                           name="audio_answer2"
                                                           id="audio_answer2"
                                                           disabled
                                                           value = {this.state.audio_answer2}
                                                    />
                                                </div>
                                            </div>
                                            <div className=" personBlock">
                                                <div className="clearfix blockTranslate border-bottom-none translate_answer2">
                                                    <p className="title">Translate</p>
                                                    {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.situation_one ?
                                                        <div className="col-md-12">
                                                            {this.renderTranslate('answer2')}
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :""}

                                {this.state.type == '2'|| type.initialValue == '2' ?
                                    <div className="speakFunc">
                                        <div className="first_situation">
                                            <div className='clearfix mb10'>
                                                <div className="col-md-4">
                                                    <label>Situation phrase bot #1</label>
                                                </div>

                                                <div className='col-md-2'>
                                                    <label htmlFor="audio_bot1" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className={audio_bot1.touched && !audio_bot1.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="audio_bot1"
                                                           id="audio_bot1"
                                                           onChange={this.handleChange}
                                                    />

                                                    <input type="text"
                                                           className="form-control"
                                                           name="audio_bot1"
                                                           id="audio_bot1"
                                                           placeholder={audio_bot1.initialValue ? audio_bot1.initialValue :"File"}
                                                           disabled
                                                           value = {this.state.audio_bot1}
                                                    />
                                                </div>
                                            </div>
                                            <div className='clearfix' style={{'marginBottom': '10px'}}>
                                                <div className="col-md-4">
                                                    <label htmlFor="text1">Situation phrase bot #1</label>
                                                </div>
                                                <div className={ text1.touched && !text1.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                                <textarea className="form-control"
                                                          name="text1"
                                                          id="text1"
                                                          {...text1}
                                                />
                                                </div>
                                            </div>
                                            <div className='clearfix mb10'>
                                                <div className="col-md-4">
                                                    <label>Situation phrase person #1</label>
                                                </div>

                                                <div className='col-md-2'>
                                                    <label htmlFor="audio_answer1" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className={audio_answer1.touched && !audio_answer1.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="audio_answer1"
                                                           id="audio_answer1"
                                                           onChange={this.handleChange}
                                                    />

                                                    <input type="text"
                                                           placeholder={audio_answer1.initialValue ? audio_answer1.initialValue :"File"}
                                                           className="form-control"
                                                           name="audio_answer1"
                                                           id="audio_answer1"
                                                           disabled
                                                           value = {this.state.audio_answer1}
                                                    />
                                                </div>
                                            </div>
                                            <div className='clearfix'>
                                                <div className="col-md-4">
                                                    <label htmlFor="phrase_audio_answer1">Sentence in the foreign language</label>
                                                </div>
                                                <div className={ phrase_audio_answer1.touched && !phrase_audio_answer1.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                    <textarea className="form-control"
                                              name="phrase_audio_answer1"
                                              id="phrase_audio_answer1"
                                              data-block="hint1"
                                              {...phrase_audio_answer1}
                                              onChange={this.addWordSelect}
                                    />
                                                </div>
                                            </div>

                                            <div className="clearfix addWordBlock missed_words_block" >
                                                <div className="col-md-4">
                                                    <label>Hint</label>
                                                </div>
                                                <div className={missed_words1.touched && !missed_words1.valid  ? 'col-md-4 has-error' : 'col-md-4'}>
                                                    <div dangerouslySetInnerHTML={{__html: missed_words1.initialValue}} style={{cursor: 'pointer'}} id="hint1" name="hint1" className="hint_block"></div>
                                                </div>
                                            </div>

                                            <div className="clearfix mb10 without-border" id="time_to_speak">
                                                <div className="col-md-4">
                                                    <label htmlFor="time_answer1">Timer <span>(seconds)</span></label>
                                                </div>
                                                <div className={time_answer1.touched && !time_answer1.valid  ? 'col-md-4 has-error' : 'col-md-4'}>
                                                    <input type="number"
                                                           name="time_answer1"
                                                           className="form-control"
                                                           id="time_answer1"
                                                           placeholder="Seconds"
                                                           {...time_answer1}
                                                    />
                                                </div>
                                            </div>

                                            <div className=" personBlock">
                                                <div className="clearfix blockTranslate border-bottom-none translate_time_answer1">
                                                    <p className="title">Translate</p>
                                                    {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.situation_one ?
                                                        <div className="col-md-12">
                                                            {this.renderTranslate('audio_answer1')}
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                        <div className="first_situation">
                                            <div className='clearfix mb10'>
                                                <div className="col-md-4">
                                                    <label>Situation phrase bot #2</label>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="audio_bot2" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className={audio_bot2.touched && !audio_bot2.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="audio_bot2"
                                                           id="audio_bot2"
                                                           onChange={this.handleChange}
                                                    />

                                                    <input type="text"
                                                           placeholder={audio_bot2.initialValue ? audio_bot2.initialValue :"File"}
                                                           className="form-control"
                                                           name="audio_bot2"
                                                           id="audio_bot2"
                                                           disabled
                                                           value = {this.state.audio_bot2}
                                                    />
                                                </div>
                                            </div>
                                            <div className='clearfix' style={{'marginBottom': '10px'}}>
                                                <div className="col-md-4">
                                                    <label htmlFor="text1">Situation phrase bot #2</label>
                                                </div>
                                                <div className={ text2.touched && !text2.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                                <textarea className="form-control"
                                                          name="text2"
                                                          id="text2"
                                                          {...text2}
                                                />
                                                </div>
                                            </div>
                                            <div className='clearfix mb10'>
                                                <div className="col-md-4">
                                                    <label>Situation phrase person #2</label>
                                                </div>

                                                <div className='col-md-2'>
                                                    <label htmlFor="audio_answer2" className="btn btn-primary pull-left">Choose file</label>
                                                </div>
                                                <div className={audio_answer2.touched && !audio_answer2.valid ? 'col-md-2 has-error' : 'col-md-2'}>
                                                    <input type="file"
                                                           style={{display: 'none'}}
                                                           name="audio_answer2"
                                                           id="audio_answer2"
                                                           onChange={this.handleChange}
                                                    />

                                                    <input type="text"
                                                           placeholder={audio_answer2.initialValue ? audio_answer2.initialValue :"File"}
                                                           className="form-control"
                                                           name="audio_answer2"
                                                           id="audio_answer2"
                                                           disabled
                                                           value = {this.state.audio_answer2}
                                                    />
                                                </div>
                                            </div>

                                            <div className='clearfix'>
                                                <div className="col-md-4">
                                                    <label htmlFor="phrase_audio_answer2">Sentence in the foreign language</label>
                                                </div>
                                                <div className={ phrase_audio_answer2.touched && !phrase_audio_answer2.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                    <textarea className="form-control"
                                              name="phrase_audio_answer2"
                                              id="phrase_audio_answer2"
                                              data-block="hint2"
                                              {...phrase_audio_answer2}
                                              onChange={this.addWordSelect}
                                    />
                                                </div>
                                            </div>

                                            <div className="clearfix addWordBlock missed_words_block" >
                                                <div className="col-md-4">
                                                    <label>Hint</label>
                                                </div>
                                                <div className={missed_words2.touched && !missed_words2.valid  ? 'col-md-4 has-error' : 'col-md-4'}>
                                                    <div dangerouslySetInnerHTML={{__html: missed_words2.initialValue}} style={{cursor: 'pointer'}} id="hint2" name="hint2" className="hint_block"></div>
                                                </div>
                                            </div>

                                            <div className="clearfix mb10 without-border" id="time_to_speak">
                                                <div className="col-md-4">
                                                    <label htmlFor="time_answer2">Timer <span>(seconds)</span></label>
                                                </div>
                                                <div className={time_answer2.touched && !time_answer2.valid  ? 'col-md-4 has-error' : 'col-md-4'}>
                                                    <input type="number"
                                                           name="time_answer2"
                                                           className="form-control"
                                                           id="time_answer2"
                                                           placeholder="Seconds"
                                                           {...time_answer2}
                                                    />
                                                </div>
                                            </div>

                                            <div className=" personBlock">
                                                <div className="clearfix blockTranslate border-bottom-none translate_time_answer2">
                                                    <p className="title">Translate</p>
                                                    {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.lang.situation_one ?
                                                        <div className="col-md-12">
                                                            {this.renderTranslate('audio_answer2')}
                                                        </div>
                                                        : ""
                                                    }
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    :""}
                            </div>
                            <div className="col-md-12">
                                <div className="white-block clearfix">
                                    {this.props.lang.error_situation && this.props.lang.error_situation.response ? <p className="errorForm text-center"> {this.props.lang.error_situation.response.data.number}</p> : ''}
                                    <div className="col-md-12 text-center button-group">
                                        <Link to={"/language/learning/edit/"+this.props.params.id+"/live_situations/"} className="btn btn-default">Cancel</Link>
                                        {this.props.params.id_situation ?
                                            <button type="button" onClick={this.delRuleOpenModal} className="btn btn-danger">Delete</button>
                                            :""}
                                        <button type="submit" className="btn btn-primary">Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :""}

                </form>
                <div className="modal fade" id="DelSituation" tabIndex="-1" role="dialog" aria-labelledby="DelSituationLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelSituation" />
                                <p>Do you really want to delete this situation {this.props.lang.situation_one ? <span>{this.props.lang.situation_one.title}</span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delRule} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

const validate=(values)=>{
    const errors = {};
    if(!values.title){
        errors.title = 'Enter a title'
    }
    if(!values.number){
        errors.number = 'Enter a number'
    }
    // if(!values.description){
    //     errors.description = 'Enter a description'
    // }
    if(!values.person){
        errors.person = 'Enter a description'
    }
    if(!values.text1){
        errors.text1 = 'Enter a description'
    }
    if(!values.text2){
        errors.text2 = 'Enter a description'
    }
    if(values.type == '1'){
        if(!values.answer1){
            errors.answer1 = 'Enter a description'
        }
        if(!values.answer2){
            errors.answer2 = 'Enter a description'
        }
        if(!values.audio_answer1){
            errors.audio_answer1 = 'Enter a description'
        }
        if(!values.audio_answer2){
            errors.audio_answer2 = 'Enter a description'
        }
    }
    if(values.type == '2'){
        if(!values.audio_bot1){
            errors.audio_bot1 = 'Enter a description'
        }
        if(!values.audio_answer1){
            errors.audio_answer1 = 'Enter a description'
        }
        if(!values.time_answer1){
            errors.time_answer1 = 'Enter a description'
        }
        if(!values.hint1){
            errors.hint1 = 'Enter a description'
        }
        if(!values.audio_bot2){
            errors.audio_bot2 = 'Enter a description'
        }
        if(!values.audio_answer2){
            errors.audio_answer2 = 'Enter a description'
        }
        if(!values.time_answer2){
            errors.time_answer2 = 'Enter a description'
        }
        if(!values.hint2){
            errors.hint2 = 'Enter a description'
        }
        if(!values.phrase_audio_answer2){
            errors.phrase_audio_answer2 = 'Enter a description'
        }
        if(!values.phrase_audio_answer1){
            errors.phrase_audio_answer1 = 'Enter a description'
        }
    }
    return errors;
}

const mapStateToProps=(state)=>({
    lang: state.lang,
    chat: state.chat,
    initialValues: {
        title: state.lang.situation_one.title || '',
        number: state.lang.situation_one.number || '',
        type: state.lang.situation_one.type || 'select',
        person: state.lang.situation_one.person || '',
        text1: state.lang.situation_one.text1 || '',
        text2: state.lang.situation_one.text2 || '',
        description: state.lang.situation_one.description || '',
        answer2: state.lang.situation_one.answer2 || '',
        answer1: state.lang.situation_one.answer1 || '',
        hint2: state.lang.situation_one.hint2 || '',
        hint1: state.lang.situation_one.hint1 || '',
        time_answer1: state.lang.situation_one.time_answer1 || '',
        time_answer2: state.lang.situation_one.time_answer2 || '',
        audio_answer2: state.lang.situation_one.audio_answer2 || '',
        audio_answer1: state.lang.situation_one.audio_answer1 || '',
        audio_bot1: state.lang.situation_one.audio_bot1 || '',
        audio_bot2: state.lang.situation_one.audio_bot2 || '',
        phrase_audio_answer1: state.lang.situation_one.phrase_audio_answer1 || '',
        phrase_audio_answer2: state.lang.situation_one.phrase_audio_answer2 || '',
        missed_words1: state.lang.situation_one.missed_words1 || '',
        missed_words2: state.lang.situation_one.missed_words2 || '',
    }
})

export default reduxForm({
    form: 'Add Rule',
    fields: ['type', 'title', 'number', 'description', 'text1', 'text2', 'answer1',
        'answer2', 'audio_bot1', 'audio_answer1', 'time_answer1', 'hint1', 'audio_bot2', 'missed_words2', 'missed_words1',
        'audio_answer2', 'time_answer2', 'hint2', 'flang', 'person', 'phrase_audio_answer2', 'phrase_audio_answer1'],
    validate
}, mapStateToProps, {GetInterfaceLang, GetOneLanguage, deleteLiveSituations, GetOneLearningLanguage, getLiveSituations, saveRule, getDetailSituation, addLiveSituations, updateTranslationLiveSituations, DelRule, GetChatPerson, updateLiveSituations, addTranslationLiveSituations})(AddRule);



// WEBPACK FOOTER //
// ./src/components/language/addSituation.js